import { makeStyles } from '@material-ui/core/styles';
import MapOfflineBGImage from '@assets/map-offline-bg.svg'
const styles = makeStyles(({ palette,variables }) => ({
  offlineMapView:{
    width: '100%',
    height: '100%',
    backgroundRepeat: 'no-repeat !important',
    backgroundSize: 'cover !important',
    background:`url(${MapOfflineBGImage})`,
    backgroundPositionX:'center',
    backgroundPositionY:'center',
    '& .overlay':{
      justifyContent: 'center',
      display: 'flex',
      alignItems: 'center',
      width:'100%',
      height:'100%',
      backgroundColor: 'rgba(0,0,0,0.55)',
      '& .offlineWarningIcon':{
        color: palette?.jet?.containerDefault,
        background:palette?.jet?.supportError,
        width:'67px',
        height:'67px',
        borderRadius:variables?.radiusRoundedE,
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
      }
    }
  }
}));

export default styles;
